const readFromCache = (client: any, query: any, variables: any) => {
  const data = client.readQuery({
    query,
    variables,
  });

  return data;
};

export default readFromCache;
